import { useEffect, useState, useCallback } from "react";
import RModal from "../../Rsuite/Modal";
import * as S from "./styles";
import { CustomButton } from "../../CustomButton";
import { List, Checkbox, Input, InputGroup } from "rsuite";
import SearchIcon from '@rsuite/icons/Search';
import api from "../../../services/api";
import { useAuth } from "../../../hooks/auth";
import { toastError } from "../../../toasts";

export const LinkAdditionals = ({ open, close, additionalsGroup, additionalsSelected, setAdditionals }) => {
  const { id_empresa } = useAuth();
  const [adds, setAdds] = useState([]);
  const [filteredAdditionals, setFilteredAdditionals] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);

  const loadAdditionals = useCallback(async () => {
    setLoading(true);
    try {
      const response = await api.get(`/produto/listarAdicionais/${id_empresa}`);
      const availableAdditionals = response.data.filter(item => {
        return !additionalsSelected.some(selected => selected.Id === item.Id);
      });

      setAdds(availableAdditionals);
      setFilteredAdditionals(availableAdditionals);
    } catch (error) {
      console.error("Erro ao carregar adicionais:", error);
    } finally {
      setLoading(false);
    }
  }, [id_empresa, additionalsSelected]);

  useEffect(() => {
    if (open) {
      loadAdditionals();
      setSelectedItems([]);
      setSearch("");
    }
  }, [open, loadAdditionals]);

  useEffect(() => {
    const filtered = adds.filter(item =>
      item.Descricao.toLowerCase().includes(search.toLowerCase())
    );
    setFilteredAdditionals(filtered);
  }, [search, adds]);

  const handleSelect = (value, checked) => {
    if (checked) {
      setSelectedItems([...selectedItems, value]);
    } else {
      setSelectedItems(selectedItems.filter(id => id !== value));
    }
  };

  const handleSaveLinks = async () => {
    if(!selectedItems.length) {
      toastError("Nenhum adicional selecionado para adicionar.");
      return;
    };

    const itemsToAdd = adds
      .filter(item => selectedItems.includes(item.Id))
      .map(item => ({
        ...item,
        Grupo: additionalsGroup?.Id,
        IsAdicional: true,
        TipoProduto: 'ADICIONAL'
      }));

      if(!itemsToAdd.length) {
        toastError("Nenhum adicional selecionado para adicionar.");
        return;
      }

    await api.post(`/produto/alterar-varios`, itemsToAdd)
    .then((response) => {
      setAdditionals((prev) => [...prev, ...response.data]);
      close();
    }).catch(() => {
      toastError("Erro ao vincular adicionais. Tente novamente.");
    })
  };

  return (
    <RModal
      open={open}
      onClose={close}
      title={'Vincular Adicionais'}
      size="md"
      footer={
        <S.Footer>
          <div />
          <S.ButtonContainer>
            <CustomButton appearance="subtle" onClick={close}>
              Cancelar
            </CustomButton>

            <CustomButton
                appearance="primary"
                onClick={handleSaveLinks}
                disabled={selectedItems.length === 0}
            >
                Adicionar ({selectedItems.length})
            </CustomButton>
          </S.ButtonContainer>
        </S.Footer>
      }
    >
      <S.Content>
        <S.SearchContainer>
          <InputGroup inside style={{ width: '100%' }}>
            <InputGroup.Addon>
              <SearchIcon />
            </InputGroup.Addon>
            <Input
              placeholder="Buscar adicional existente..."
              value={search}
              onChange={setSearch}
            />
          </InputGroup>
        </S.SearchContainer>

        <S.ListContainer>
          {loading ? (
              <S.LoadingText>Carregando...</S.LoadingText>
          ) : filteredAdditionals.length > 0 ? (
              <List hover>
                {filteredAdditionals.map((item) => (
                  <List.Item key={item.Id} style={{ padding: 0 }}>
                    <S.ListItemContent>
                      <Checkbox
                        checked={selectedItems.includes(item.Id)}
                        onChange={(_, checked) => handleSelect(item.Id, checked)}
                      >
                          <S.ItemLabel>{item.Descricao}</S.ItemLabel>
                      </Checkbox>
                      <S.ItemPrice>
                        {item.PrecoVenda ? `R$ ${parseFloat(item.PrecoVenda).toFixed(2)}` : ''}
                      </S.ItemPrice>
                    </S.ListItemContent>
                  </List.Item>
                ))}
              </List>
          ) : (
            <S.EmptyText>
              Nenhum adicional encontrado.
            </S.EmptyText>
          )}
        </S.ListContainer>
      </S.Content>
    </RModal>
  );
}
